/* Cookie Functions */
var Cookie = {
  create: function (name, value, days) {
    var expires,
      domain = window.location.hostname.substr(window.location.hostname.indexOf('.'));
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }
    else {
      expires = "";
    }
    var secure = "";
    if (location.protocol.match(/https/)) {
      secure = ";secure";
    }

    if (Cookie.shouldAddCookie(name)) {
      document.cookie = name + '=' + value + expires + '; domain=' + domain + '; path=/;' + secure;
    } else {
      //to make sure remove all type of cookie delete
      document.cookie = name + '=' + expires + ';';
      document.cookie = name + '=' + expires + '; domain=' + domain + ';';
      document.cookie = name + '=' + expires + '; domain=' + domain + '; path=/;';
      document.cookie = name + '=' + expires + '; domain=' + domain + '; path=/;' + secure;
    }
  },

  read: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  erase: function (name) {
    Cookie.create(name, "", -1);
  },

  /**
   * Function to Create Cookies with Path.
   */
  createWithPath: function (name, value, days) {
    var expires,
      domain = window.location.hostname.substr(window.location.hostname.indexOf('.'));
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    var secure = "";
    if (location.protocol.match(/https/)) {
      secure = ";secure";
    }
    document.cookie =
      name +
      "=" +
      value +
      expires +
      "; domain=" +
      domain +
      "; path=" +
      window.location.pathname +
      ";" +
      secure;
  },
  shouldAddCookie: function (cookie) {
    if (
      REQUIRED_COOKIES.some(function(item) {
        return cookie.includes(item);
      }) ||
      document.cookie.includes(stage_env_cookie_prefix +"UserOptCookie=true")
    ) {
      return true;
    }
    return false;
  }
};
